function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#733EA3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 5.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.8 0H1.2C.54 0 0 .45 0 1v9l2.4-2h8.4c.66 0 1.2-.45 1.2-1V1c0-.55-.54-1-1.2-1z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#733EA3",
  cx: "3.4",
  cy: "4",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#733EA3",
  cx: "6.4",
  cy: "4",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#733EA3",
  cx: "9.4",
  cy: "4",
  r: "1"
})))));